import { __PROD__ } from "const/properties";

const HANPASS_AOS_WEBVIEW = /APP_HANPASS_AOS/;
const HANPASS_IOS_WEBVIEW = /APP_HANPASS_IOS/;
const SAFARI = /Safari/;

const HARDCODED_GOHANPASS_HOME_URL = "https://dev-go.hanpass.com/home";
const GOHANPASS_HOME_URL = process.env.REACT_APP_GOHANPASS_HOME_URL?.trim();
// const HISTORY_BACK_FALLBACK_DELAY_MS = 700;

type HanpassInspectState = {
  href: string;
  userAgent: string;
  historyLength: number;
  historyBackHintUrl: string | null;
  fallbackUrl: string;
  closeTargetOnCurrentUA: string;
  isHanpassApp: boolean;
};

const canUseWindow = () => typeof window !== "undefined";

const normalizeHttpsUrl = (url: string) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url}`;
};

const getGohanpassHomeUrl = () =>
  normalizeHttpsUrl(GOHANPASS_HOME_URL || HARDCODED_GOHANPASS_HOME_URL);

const getHanpassInspectState = (): HanpassInspectState => {
  const hanpassApp = isHanpassApp();
  const gohanpassHomeUrl = getGohanpassHomeUrl();

  return {
    href: window.location.href,
    userAgent: navigator.userAgent,
    historyLength: window.history.length,
    historyBackHintUrl: document.referrer || null,
    fallbackUrl: gohanpassHomeUrl,
    closeTargetOnCurrentUA: hanpassApp
      ? "http://finish"
      : gohanpassHomeUrl,
    isHanpassApp: hanpassApp,
  };
};

export const installHanpassInspectBridge = () => {
  if (__PROD__) return;
  if (!canUseWindow()) return;

  window.__hanpassInspect = {
    state: () => {
      const snapshot = getHanpassInspectState();
      // eslint-disable-next-line no-console
      console.log("[HanpassInspect] state", snapshot);
      return snapshot;
    },
    historyBack: () => {
      window.history.back();
    },
    goFallback: () => {
      document.location.href = getGohanpassHomeUrl();
    },
  };
};

/** 한패스 앱 내 웹뷰 여부 */
export const isHanpassApp = () => {
  const ua = navigator.userAgent;
  if (HANPASS_AOS_WEBVIEW.test(ua)) return true;
  if (HANPASS_IOS_WEBVIEW.test(ua) && !SAFARI.test(ua)) return true;
  return false;
};

/** Hanpass/gohanpass 종료 처리 */
export const closeHanpassWebView = () => {
  if (isHanpassApp()) {
    document.location.href = "http://finish";
    return;
  }

  document.location.href = getGohanpassHomeUrl();
};

// export const historyBackWithHanpassFallback = (
//   delayMs = HISTORY_BACK_FALLBACK_DELAY_MS
// ) => {
//   if (!canUseWindow()) return;

//   if (isHanpassApp()) {
//     closeHanpassWebView();
//     return;
//   }

//   const beforeHref = window.location.href;
//   window.history.back();

//   window.setTimeout(() => {
//     if (window.location.href === beforeHref) {
//       closeHanpassWebView();
//     }
//   }, delayMs);
// };
